module.exports = __webpack_public_path__ + "img/3.02dd2924.jpg";